<case-navigation></case-navigation>
<router-outlet></router-outlet>
